// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabs_container__jxkXO","tab":"Tabs_tab__dGFBS","selected":"Tabs_selected__p4YX6","outline":"Tabs_outline__fhBiz"};